import { useState, } from "react";

export default function ServiceGeneral(props) {

  // const chooseCleaning = (serviceId) => {
  //   props.service.extraData[0] = serviceId;
  //   setChooseCleaning(serviceId);
  //   //update service caption
  //   props.machineType.cleaning.map(function (obj, i) {
  //     if(obj.id==serviceId){
  //       props.service.name=obj.name;
  //     }
  //   });
  // }

  
  let content;
  if (props.service.description != '') {
    content = <div>
      <h4 className='ui header'>Beschreibung</h4>
      {props.service.description}
      <div className='ui divider'></div>
    </div>
  }

  return (
    <div>
      Haben Sie den Auftrag ausgeführt?
      {content}
    </div>
  );
}